import jQuery from 'jquery';

// var stationHacks = require('../util/custom/station-hacks.js');

import lang from './lang/eng.js';


var ConfigDefaults = {

  debug: false, 

  translation: lang,

  onLoad: function(){

    return true;

  },

  afterRouter: function(){

    return true;

  },

  // Information about the station
  station: {

    // Uses document's domain by default.
    domain: document.domain,

    // Title of station, used as a fallback for show title.
    title: "",

  },

  API: {

    live: {

      // Connect to the Live API with Socket.IO
      enable: true,

      callback: function(data){
        return true;
      },

      include: {
        tracks: {
          limit: 50
        },
        streams: { 

          // !!! Idea for having subscription streams
          authorize: "USER_AUTH_TOKEN_GOES_HERE" // returns the streams
        
        }
      }

    },
  
  },

  content: {

    pathPrefix: ''

  },

  audio: {

    live: {

      URL: "",

    },

    beforeIcon: "Listen",

    toolbar: {

      // Whether enable the toolbar and its functions
      enable: true,

      showImageSize: "sm",

      albumArt: false,

      onRender: function(){}

    },

    players: {
      backgroundColor: "rgba(0,0,0,.2)",
      textLightOrDark: "dark"
    },

    onInitialized: function(){
      return true;
    }

  },

  // Options for the Creek Shows framework
  shows: {

    data: null,

    container: "#Creek-Shows",

    // Scroll to the top of this element on Vue.js raouter page change.
    //  - Uses a CSS/jQuery-compatible selector. 
    //  - Default: body
    scrollToElement: "body",

    // Create a placeholder Vue instance for the Schedule
    buildVueInstance: true,

    // Cache for API data
    schedule: {
      data: null
    },
    all: {
      data: null
    },

    // Allows you to call them "programs" or
    //  "shows" or "content" or whatever.
    // (Used for the page <title> updater.)
    showsName: "shows",

    /*--------------------------------------

    Path Prefix for Shows Routes:

    // Router is only on "/shows" page
    SinglePage: ""
    iframe: ""
    
    // Router is global
    Vue.js App: "/shows"

    // Router is on "/shows" but only used for schedule itself,
    // since shows/broadcasts/profiles have their own pages.
    WordPress: "/shows"
    Creek: "/shows"

    */


    // The built-in router that creates a dedicated Shows page by injecting page content for shows, broadcasts, and hosts directly into the same container box as the schedule.
    router: {
    
      basePath: "",
      
      baseRoutePath: "",

      pathPrefix: "",

      enable: false,

      // Enables or disables updating page titles
      enableTitles: true,

      // HTML to display while an external page is loading
      loadingHTML: '<div class="creek-loading-container"><i class="creek-loading-icon fa fa-spinner fa-spin fa-2x"></i></div>',

      scrollOffset: -20,

    },

  },



  persist: {

    /*

    Documentation notes:

    In iframe persistence:
    - Use .creek-persist-link to make links target the iframe rather than the window.
    - Use .creek-persist to make that element get persisted, rather than deleted when the page loads.

    */

    // Persistence is disabled by default.
    enable: false,

    // Default to "iframe"
    type: "iframe",

    settings: {

      //  IFRAME Persistence:
      //  "Moves" everything into an iframe, except for the main audio toolbar, <head>, <body>, and a few user-defined elements.
      iframe: {

        //An internal state indicator for iframe-based persistence.
        insideIframe: false,

        domain: document.domain,

        mainElement: "#creek-audio-toolbar",

        runSingleFireEvents: function(){
          return true;
        },

        forceUpdateURL: false,

        //  extra-slash is the only option currently
        recursionFixType: "extra-slash",

        //  new-window or replace-window
        externalLinkBehavior: "new-window",

        //ignorePaths:
        // If these strings are found in the link's 'href' attribute, then clicking on them break the page out of the 
        ignoreURLsWith: [
          '/wp-admin',
          '/admin'
        ]

      },

      // Persistence through Content Injection:
      //  This persistence technique intercepts link clicks, and injects the intended page content into the main page container. This, rather than refreshing the page and breaking any active audio players.
      singlepage: {

        // domain:
        //  The domain of the website. If a link contains this domain, then follow normal content injection behavior, rather than treating it like an external link that should send the browser entirely to the URL. (Example: if a link href has a full URL like "http://station-name.org/about" rather than just "/about")
        domain: document.domain,

        // EXPERIMENTAL FEATURE
        // loadNewAssets:
        //  Load new CSS / JS: Iterate over the JS and CSS objects in the intended page, find ones that aren't already on the page, and add them to the <head> or <body> of the document.
        loadNewAssets: false,

        // !!!WXNA
        // container:
        //  ID of container element. Leave out the: #
        container: "#creek-persist-container",
        //  container: "#page",

        // Loading indicator: How long to wait before showing the loading indicator.
        loadingIndicatorDelay: 800,

        // Loading indicator: Whether or not the loading indicator is currently active.
        loadingStatus: false,

        // onLoading: useful for doing things while the page is loading, especially displaying a loading bar.
        onLoading: function(){ },

        // onLoading: useful for doing things when the page is done loading, especially for hiding a loading bar.
        onLoaded: function(){ },

        // Ran when the page is done loading.
        onComplete: function(){ },

        //onCompleteArray:
        // An array of functions that are all called when the page is done loading, allowing you to push() functions to this array. Useful in cases where there are multiple callbacks that must be fired, and these callbacks are located in different scripts loaded at different times in the page's lifetime.
        onCompleteArray: [],

        //One last callback, ran after all onCompleteArray functions above.
        onCompleteFinal: function(){ },

        //ignorePaths:
        // If these strings are found in the link's 'href' attribute, then clicking on them will fully refresh the page, bypassing the persistence function (where otherwise the intended page content is injected into the DOM).
        // ignorePaths: stationHacks.addToIgnorePaths(['/wp-admin/'])

      }
    }
  }

}

//---------------------------------------------------------------
//
//  Prepare settings for usage in the framework.
//  
//  - Merge settings above with settings from Creek.init({...}) 
//  - Set up various special settings and workarounds.
//
//---------------------------------------------------------------

//Combine defaults with any options provided in Creek.init({...})
export default {

  init: function(config){

    // console.log(config);

    var defaults = ConfigDefaults;

    //----------------------------------
    // Set up shortcut variables:
    //----------------------------------
    defaults.station.domain = config.domain || defaults.station.domain;
    defaults.audio.live.URL = config.stream || defaults.audio.live.URL;

    //----------------------------------
    // Combine data:
    //----------------------------------
    var newDataPlusDefaults = jQuery.extend(true, {}, defaults, config);

    // console.log(newDataPlusDefaults);

    //----------------------------------
    // Router Link Fixes: 
    // - Set up links depending on whether router is used.
    //----------------------------------
    if(newDataPlusDefaults.shows.router.enable){

      newDataPlusDefaults.shows.prefix = newDataPlusDefaults.shows.router.pathPrefix + newDataPlusDefaults.shows.router.showsPath;
      
      newDataPlusDefaults.content.pathPrefix = newDataPlusDefaults.shows.router.pathPrefix;
      newDataPlusDefaults.content.showsPath = newDataPlusDefaults.shows.router.showsPath;

      //Set up link replacements
      newDataPlusDefaults.shows.router.linkReplacements = {
        "/shows": newDataPlusDefaults.shows.router.pathPrefix + newDataPlusDefaults.shows.router.showsPath,
        "/shows/": newDataPlusDefaults.shows.router.pathPrefix + newDataPlusDefaults.shows.router.showsPath,
        "/broadcasts/view/": newDataPlusDefaults.shows.router.pathPrefix + newDataPlusDefaults.shows.router.showsPath + "broadcasts/",
        "/broadcasts/": newDataPlusDefaults.shows.router.pathPrefix + newDataPlusDefaults.shows.router.showsPath + "broadcasts/",
        "/profiles/": newDataPlusDefaults.shows.router.pathPrefix + newDataPlusDefaults.shows.router.showsPath + "profiles/"
      }

    }
    //Else Router is not used, so use a flat URL and path
    else{

      //!!! replace this
      newDataPlusDefaults.shows.prefix = "/shows/";
      
      // ...and use these
      newDataPlusDefaults.content.pathPrefix = "/";
      newDataPlusDefaults.content.showsPath = "shows/";

    }

    newDataPlusDefaults.content.getPath = function(type, id){
      return newDataPlusDefaults.content.pathPrefix + type + "/" + id;
    }

    // console.log(newDataPlusDefaults.station.domain)

    // This URL is used to get remote content
    newDataPlusDefaults.content.baseURLForAPI = "https://" + newDataPlusDefaults.station.domain;

    // Debug output:
    // Creek.debug.log(newDataPlusDefaults);
    // Creek.debug.log(config);

    return newDataPlusDefaults;

  }

}
